import ParticipantsList from "components/Admin/Batches/List/ParticipantsList"
import React from "react"

const ParticipantsListPage = () => {
    return (
        <React.Fragment>
            <ParticipantsList />
        </React.Fragment>
    )
}
export default ParticipantsListPage
